import { render, staticRenderFns } from "./SubCategoryComponent.vue?vue&type=template&id=8b3b7154&scoped=true&"
import script from "./SubCategoryComponent.vue?vue&type=script&lang=ts&"
export * from "./SubCategoryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SubCategoryComponent.vue?vue&type=style&index=0&id=8b3b7154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3b7154",
  null
  
)

export default component.exports